export interface IRequiredField {
    fieldName: string,
    fieldFromFile: string
}